import merge from "lodash/merge";
import { ToastsStore } from "react-toasts";
import { toaster, apiErrorMessage } from "../function.js";

/** Browser/extension fetch wrappers sometimes reject a detached promise with this. */
export const isDetachedFetchWrapperError = (reason) => {
  const message = String((reason && reason.message) || reason || "");
  return message.indexOf("M_ID") !== -1;
};

export const post = async ({ url, body, headers, failure, dispatch }) => {
  try {
    const res = await fetch(url, {
      method: "POST",
      // headers: headers,
      headers: merge(
        {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        headers
      ),
      body: JSON.stringify(body),
    });

    const data = await res.json();
    if (data && data.code === 401) {
      localStorage.removeItem("state");
    }

    return data;
  } catch (e) {
    if (failure) {
      dispatch({ type: failure });
    }
    return {
      code: 0,
      message: "Unable to reach server. Please try again.",
    };
  }
};

export const get = async ({ url, success, failure, headers, dispatch, signal }) => {
  try {
    const res = await fetch(url, {
      method: "GET",
      signal,
      headers: merge(
        {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        headers
      ),
    });

    const data = await res.json();
    if (data && data.code === 401) {
      localStorage.removeItem("state");
      window.location.href = "/login";
    }

    return data;
  } catch (e) {
    if (e && e.name === "AbortError") {
      throw e;
    }
    if (failure) {
      dispatch({ type: failure });
    }
    return {
      code: 0,
      message: "Unable to reach server. Please try again.",
    };
  }
};

export const put = async ({
  url,
  body,
  success,
  failure,
  dispatch,
  headers,
}) => {
  try {
    const res = await fetch(url, {
      method: "PUT",
      headers: merge(
        {
          "Content-Type": "application/json",
        },
        headers
      ),
      body: JSON.stringify(body),
    });

    const data = await res.json();
    return data;
  } catch (e) {
    if (failure) {
      dispatch({ type: failure });
    }
    return {
      code: 0,
      message: "Unable to reach server. Please try again.",
    };
  }
};

export const delet = async ({
  url,
  body,
  success,
  failure,
  dispatch,
  headers,
}) => {
  try {
    const res = await fetch(url, {
      method: "DELETE",
      headers: merge(
        {
          "Content-Type": "application/json",
        },
        headers
      ),
      body: JSON.stringify(body),
    });

    const data = await res.json();

    if (res.status >= 200 && res.status < 400) {
      toaster(ToastsStore, "success", data.message);
      dispatch({ type: success, data });
      return data;
    } else {
      if (data.message || data.debug_message) {
        toaster(ToastsStore, "error", apiErrorMessage(data));
      }
      dispatch({ type: failure });
    }
  } catch (e) {
    if (failure) {
      dispatch({ type: failure });
    }
    return {
      code: 0,
      message: "Unable to reach server. Please try again.",
    };
  }
};
